import type { RootState } from 'app'
import { createSelector } from '@reduxjs/toolkit'
import { Option } from 'shared/types'

export const getSettingsState = (state: RootState) => state.common.settings

export const getCountries = createSelector(
  getSettingsState,
  state => state.countries
)

export const getLoadingState = createSelector(
  getSettingsState,
  state => state.loadingState
)

export const getphonePrefixesOptions = createSelector(getSettingsState, state =>
  state.countries?.map(
    country =>
      ({
        title: country.phonePrefix,
        value: country.id,
      } as Option<string, number>)
  )
)

export const getCountriesOptions = createSelector(getSettingsState, state =>
  (state.countries || []).map(
    country =>
      ({
        title: country.name,
        value: country.id,
      } as Option<string, number>)
  )
)

export const getLanguages = createSelector(
  getSettingsState,
  state => state.languages
)

export const getSelectedLanguage = createSelector(
  getSettingsState,
  state => state.selectedLanguage
)

export const getUpdateLanguage = createSelector(
  getSettingsState,
  state => state.updateLanguage
)
